import AsyncStorage from '@react-native-async-storage/async-storage';
import { DateTime } from 'luxon';
import { API } from '../../service/api';
import { WorkerActions } from '../reducers/workerReducer';

export const login = (userData, navigation) => (dispatch) => {
  dispatch({ type: WorkerActions.TOGGLE_LOADER });
  API.post('/auth', {
    email: userData.email,
    senha: userData.pass,
    perfil: 'COLABORADOR',
  }).then(({ data }) => {
    if (data.success) {
      const { id_colaborador } = data.data;
      AsyncStorage.setItem('PROFILE', 'COLABORADOR');
      AsyncStorage.setItem('ID', id_colaborador);
      dispatch({ type: WorkerActions.UPDATE_DATA, dataType: 'workerData', dataValue: data.data });
      dispatch({ type: WorkerActions.UPDATE_DATA, dataType: 'isError', dataValue: false });
      dispatch(getPlanData(id_colaborador, navigation));
    }
  }).catch(() => {
    dispatch({ type: WorkerActions.TOGGLE_ERROR });
  }).finally(() => {
    dispatch({ type: WorkerActions.TOGGLE_LOADER });
  });
};

export const getPlanData = (id_colaborador, navigation) => (dispatch) => {
  API.post('/search/plano', {
    where: `id_plano IN ( SELECT id_plano FROM empresa e JOIN colaborador c ON e.id_empresa = c.id_empresa WHERE id_colaborador = '${id_colaborador}' )`,
  }).then(({ data }) => {
    dispatch({ type: WorkerActions.UPDATE_DATA, dataType: 'planData', dataValue: data.data[0] });
    navigation.navigate('Profile Worker');
  });
};

export const getClasses = (classType, dataWorker) => (dispatch) => {
  dispatch({ type: WorkerActions.UPDATE_DATA, dataType: 'classesData', dataValue: [] });
  dispatch({ type: WorkerActions.TOGGLE_LOADER });
  const now = DateTime.now().toFormat('yyyy-LL-dd');

  const getAsset = async (id_aula) => API.post('/search/acervo', { where: `id_acervo in (select id_acervo from aula where id_aula = '${id_aula}' )` });
  API.post('/search/aula', {
    where: dataWorker
      ? `id_empresa = '${dataWorker.id_empresa}' and id_setor = '${dataWorker.id_setor}' and cd_tipo = '${classType}'  and (data = '${now}' OR data is null)`
      : `cd_tipo = '${classType}'  and (data = '${now}' OR data is null)`,
  })
    .then(async ({ data }) => {
      const { data: classesData } = data;
      if (classesData.length) {
        if (classType === 'GRAVADA') {
          const results = await Promise.all(
            classesData.map(async (classData) => {
              const asset = await getAsset(classData.id_aula);
              return asset.data.data[0];
            }),
          );
          const videoData = results;

          classesData.forEach((classData, index) => {
            classesData[index].video = videoData[index]?.video;
          });
        }
      }

      dispatch({ type: WorkerActions.UPDATE_DATA, dataType: 'classesData', dataValue: classesData });
    })
    .finally(() => {
      dispatch({ type: WorkerActions.TOGGLE_LOADER });
    });
};

export const rateClass = (rateData, navigation) => (dispatch) => {
  const {
    id_colaborador, id_aula, moedas, saldo, aStars, pStars, aText, pText,
  } = rateData;
  dispatch({ type: WorkerActions.TOGGLE_LOADER });
  const now = DateTime.now().toFormat('yyyy-LL-dd');
  API.post('/search/colaborador_aula', { where: `id_aula = '${id_aula}' AND id_colaborador = '${id_colaborador}'` })
    .then(({ data }) => {
      const hasRated = data.data.length;
      if (hasRated > 0) {
        alert('Você já avaliou essa aula!\nVoltando ao Menu Inicial');
      } else {
        API.put(`/update/colaborador/${id_colaborador}`, { saldo_moedas: Number(saldo) + Number(moedas) }).then(() => {
          API.get(`/get/colaborador/${id_colaborador}`).then((response) => {
            dispatch({ type: WorkerActions.UPDATE_DATA, dataType: 'workerData', dataValue: response.data.data[0] });
          });
        });
        API.post('/create/colaborador_aula', {
          id_colaborador,
          id_aula,
          data_participacao: now,
          nota_aula: aStars,
          nota_profissional: pStars,
          obs_aula: aText,
          obs_profissional: pText,
        }).then((response) => {
          if (response.data.success) {
            alert('Sua avaliação foi salva com sucesso!');
          }
        });
      }
    }).finally(() => {
      navigation.navigate('Worker Profile');
      dispatch({ type: WorkerActions.TOGGLE_LOADER });
    });
};

export const getAvailablePlans = () => (dispatch) => {
  API.post('/search/plano', { where: 'cd_tipo = "PARTICULAR"' }).then(({ data: response }) => {
    const { data } = response;
    if (data.length > 0) {
      dispatch({ type: WorkerActions.SET_AVAILABLE_PLANS, availablePlans: data });
    }
  }).catch((error) => {
    console.log(error.response.data.error);
  });
};

export const confirmSubscription = (userSignUp, navigation) => () => {
  const {
    nome, cpf, telefone, email, senha, objetivo1, objetivo2, objetivo3,
    id_plano, id_profissional, segunda, terca, quarta, quinta, sexta, sabado, domingo, horario,
    group_qnt, nome2, nome3, nome4, email2, email3, email4,
  } = userSignUp;
  const userData = {
    nome, cpf, telefone, email, senha, objetivo1, objetivo2, objetivo3, qtd_alunos: group_qnt, nome2, nome3, nome4, email2: email2?.length > 0 ? email2 : null, email3: email3?.length > 0 ? email3 : null, email4: email4?.length > 0 ? email4 : null,
  };
  const userTrainerData = {
    id_plano, id_profissional, segunda, terca, quarta, quinta, sexta, sabado, domingo, horario, forma_pagamento: null, data_inicio: DateTime.now().toFormat('yyyy-LL-dd'),
  };
  API.post('/create/usuario', userData)
    .then((resp) => {
      if (resp.data.success) {
        API.post('/create/usuario_personal', { ...userTrainerData, id_usuario: resp.data.id })
          .then(() => {
            console.log('enviado.');
          })
          .catch((error) => {
            console.log('u_p', error);
          });
      }
    })
    .catch((error) => {
      console.log('u', error);
    });
};
